import { gql } from '@apollo/client';

export interface ManualEnterOrderPoolResponse {
    manualEnterOrderPool: boolean;
}

export interface ManualEnterOrderPoolVariables {
    orderIds: number[];
}

export const MANUAL_ENTER_ORDER_POOL = gql`
    mutation ManualEnterOrderPool($orderIds: [Long!]!) {
        manualEnterOrderPool(orderIds: $orderIds)
    }
`;

